import { Route, Routes } from "react-router-dom";
import { SiteLayout } from "@/components/layout";
import { HomePage } from "@/pages/Home";
import { WatchPage } from "@/pages/Watch";
import { QuizPage } from "@/pages/Quiz";
import { HistoryPage } from "@/pages/History";
import { NotFoundPage } from "@/pages/NotFound";

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route index element={<HomePage />} />
        <Route path="history" element={<HistoryPage />} />
        <Route path="watch/:videoId" element={<WatchPage />} />
        <Route path="quiz/:videoId" element={<QuizPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}